import _ from 'underscore';

const toolbarItemWithSelect = ({
  i18n, isBrandProtectionEnabled, isBrandExclusionEnabled, handleDelete, handleExclusion, handleProtection, selectedItems,
}) => ([
  ['selection-widget', {
    id: 'selection-widget',
    type: 'selection-widget',
  }],
  ['button-delete', {
    id: 'button-delete',
    type: 'button',
    classes: ['btn-link'],
    iconLeftGlyphName: 'ba-Delete',
    text: i18n.getString(_TL_('Delete')),
    onClick: handleDelete,
  }],
  ['button-exclusion', {
    id: 'button-exclusion',
    type: 'button',
    classes: ['btn-link'],
    text: i18n.getString(_TL_('Apply brand exclusion')),
    onClick: handleExclusion,
    isHide: !isBrandExclusionEnabled || selectedItems.length > 1,
  }],
  ['button-protection', {
    id: 'button-protection',
    type: 'button',
    classes: ['btn-link'],
    text: i18n.getString(_TL_('Apply brand protection')),
    onClick: handleProtection,
    isHide: !isBrandProtectionEnabled || selectedItems.length > 1,
  }],
  ['expander', {
    type: 'expander',
  }],
  ['button-clear-selection', {
    id: 'button-clear-selection',
    type: 'button-clear-selection',
  }],
]);

export function getToolbarConfig({
  i18n, isBrandProtectionEnabled, isBrandExclusionEnabled, selectedItems, handleCreate, handleDelete, handleExclusion, handleProtection,
}) {
  const toolbarSelectedConfig = new Map();
  toolbarItemWithSelect({
    selectedItems,
    i18n,
    isBrandProtectionEnabled,
    isBrandExclusionEnabled,
    handleDelete,
    handleExclusion,
    handleProtection,
  }).forEach(([key, value]) => {
    if (!value.isHide) {
      toolbarSelectedConfig.set(key, _.omit(value, 'isHide'));
    }
  });
  const toolbarUnselectedConfig = new Map([
    ['button-create', {
      id: 'button-create',
      type: 'button',
      classes: ['btn-primary'],
      iconLeftGlyphName: 'ba-Add',
      text: i18n.getString(_TL_('Create list')),
      onClick: handleCreate,
    }],
    ['predicate-list', {
      id: 'predicate-list',
      type: 'custom',
    }],
  ]);
  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}

